import { useEffect, useState } from 'react';
import { CrewFinds } from './CrewFinds';
import { useToast } from './Toast';
import { getMe, listInspirations, nameCharacter, listCharacters, type Inspiration, type Character, type Me } from '../lib/crew';
import { track } from '../analytics';

/**
 * The crew on Home (10 §10, R-04): what they found in what you made, keep or
 * discard (CrewFinds, which also arrives live); naming what came back.
 *
 * "Your crew can draw one of these" (a chosen render on a credit, and the fake
 * door on "more credits") was taken off Today on 2026-09-29; the owner expects
 * it back on /film once that is a workshop rather than a film.
 */
export function CrewHome({ onKeptChange }: { onKeptChange?: (kept: Inspiration[]) => void }) {
  const [me, setMe] = useState<Me | null>(null);
  const [chars, setChars] = useState<Character[]>([]);
  const [naming, setNaming] = useState<Record<string, string>>({});
  const { toast, show } = useToast();

  const reload = async () => {
    try {
      const [m, ins, cs] = await Promise.all([getMe(), listInspirations(), listCharacters()]);
      setMe(m); setChars(cs.sort((a, b) => (b.createdAt || 0) - (a.createdAt || 0)));
      onKeptChange?.(ins.filter((i) => i.status === 'kept'));
    } catch { /* offline or rules: the section simply stays quiet */ }
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { reload(); }, []);

  const name = async (c: Character) => {
    const n = (naming[c.id] || '').trim();
    if (!n) return;
    try { await nameCharacter(c.id, n); track('character_named'); reload(); } catch { show('Could not save the name.'); }
  };

  if (!me || me.crew !== 'on') return null;
  const unnamed = chars.filter((c) => !c.name);

  return (
    <>
      <CrewFinds onChange={reload} />
      {unnamed.length > 0 && unnamed.map((c) => (
        <div key={c.id} className="sheet" style={{ gap: 8 }}>
          <span className="label">Someone to care for</span>
          <img src={c.imageUrl} alt={c.text} className="char-img" />
          <p className="why">Your crew drew {c.kind === 'place' ? 'this' : 'someone'} from your line: “{c.text}”. {c.kind === 'place' ? 'What is it called?' : 'What’s their name?'}</p>
          <div className="row">
            <input className="input" value={naming[c.id] || ''} onChange={(e) => setNaming({ ...naming, [c.id]: e.target.value })} placeholder={c.kind === 'place' ? 'The laundromat' : 'Nightingale'} />
            <button className="btn small" onClick={() => name(c)} disabled={!(naming[c.id] || '').trim()}>Name</button>
          </div>
        </div>
      ))}
      {toast}
    </>
  );
}
